import { ECountry } from 'App/i18n/i18n.types';

import {
  AR_MINIMUM_AMOUNT_PRE_PAID,
  BR_MINIMUM_AMOUNT_PRE_PAID,
  MX_MINIMUM_AMOUNT_PRE_PAID
} from 'commons/utils/constants';

export const getMinimumAmountPerCountry = (country: ECountry) => {
  switch (country) {
    case ECountry.BRAZIL:
      return BR_MINIMUM_AMOUNT_PRE_PAID;
    case ECountry.ARGENTINA:
      return AR_MINIMUM_AMOUNT_PRE_PAID;
    case ECountry.MEXICO:
      return MX_MINIMUM_AMOUNT_PRE_PAID;
    default:
      return 0;
  }
};

export const getDefaultValuesPerCountry = (country: ECountry) => {
  switch (country) {
    case ECountry.BRAZIL:
      return ['10,00', '50,00', '100,00'];
    case ECountry.ARGENTINA:
      return [];
    case ECountry.MEXICO:
      return [];
    default:
      return [];
  }
};

export const getMaskPerCountry = (country: ECountry): string => {
  switch (country) {
    case ECountry.BRAZIL:
      return '9999999999';
    case ECountry.ARGENTINA:
      return '99999999999';
    case ECountry.MEXICO:
      return '9999999999';
    default:
      return '9999999999';
  }
};
